import { createReducer, deleteIn, isMatchId } from '../helpers';
import { api } from '../actions';

const setIsFetching = (bool) => (state) => {
    state.isFetching = bool;
};

const initialState = {
    items: [],
    next: null,
    guid: 0,
    isFetching: false,
};

export default createReducer(initialState, {
    [api.users.invites.create.request]: setIsFetching(true),
    [api.users.invites.delete.request]: setIsFetching(true),
    [api.users.invites.create.failure]: setIsFetching(false),
    [api.users.invites.delete.failure]: setIsFetching(false),
    [api.users.invites.list.failure]: setIsFetching(false),
    [api.users.invites.delete.success]: setIsFetching(false),

    [api.users.invites.create.success]: (state, action) => {
        state.items.unshift(action.result);
        state.isFetching = false;
    },
    [api.users.invites.delete.success]: (state, action) => {
        deleteIn(state.items, isMatchId(action.inviteId));
        state.isFetching = false;
    },
    [api.users.invites.list.request]: (state) => {
        state.isFetching = true;
        // state.items = state.next ? state.items : [];
    },
    [api.users.invites.list.success]: (state, action) => {
        if (action.guid && action.guid < state.guid) {
            return state;
        }

        state.items =
            action.query && action.query.next ? state.items.concat(action.result.results) : action.result.results;
        state.next = action.result.next;
        state.isFetching = false;
    },
});
